/**
 * React Query Configuration
 * Centralized query client setup with sensible defaults
 */

import { QueryClient } from '@tanstack/react-query';

/**
 * Configure Query Client with defaults
 * - staleTime: Data is considered fresh for 5 minutes
 * - gcTime: Unused data cached for 10 minutes before garbage collection
 * - retry: Retry failed requests up to 3 times
 * - retryDelay: Exponential backoff (1s, 2s, 4s)
 * - networkMode: Offline-safe mode that batches requests
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      networkMode: 'always', // Continue requests even if offline
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,
    },
    mutations: {
      retry: 1,
      networkMode: 'always',
    },
  },
});

export default queryClient;
